// Display mirror of the authoritative refund window.
//
// The real decision lives in `decideRefundRequest` inside
// `libs/data-access/src/purchases` (REFUND_WINDOW_MS there) and is re-derived
// server-side on every refund request. This copy exists because the orders
// panel (`libs/feature-components/src/lib/orders`) is a client component and
// must not pull the server-only data-access barrel into the browser bundle; it
// only decides whether to render the refund button. If the two ever disagree the server
// wins, and the buyer sees a button that returns `windowExpired`.
export const REFUND_WINDOW_MS = 7 * 24 * 60 * 60 * 1000
